export const blogsInformation = [
  {
    id: "front-end",
    name: "How does react JS work?",
    image: "https://i.ibb.co/7kCtJbB/react-work-flow.png",
    link: `/blog-details`,
    description: "It is a blog description",
    bulletPoint: [
      "bullet point -1",
      "bullet point -2",
      "bullet point -3",
      "bullet point -4",
      "bullet point -5",
    ],
  },
];
